var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.66667V8.33333H0V0ZM1.66667 1.66667V6.66667H5V1.66667H1.66667ZM8.33333 0H15V5H8.33333V0ZM10 1.66667V3.33333H13.3333V1.66667H10ZM8.33333 6.66667H15V15H8.33333V6.66667ZM10 8.33333V13.3333H13.3333V8.33333H10ZM0 10H6.66667V15H0V10ZM1.66667 11.6667V13.3333H5V11.6667H1.66667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantSummary);
export default __webpack_public_path__ + "static/media/PlantSummary.7df5680afde5923b2e0204aefea8c738.svg";
export { ForwardRef as ReactComponent };